// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1kodP","inner":"Form_inner__1_EGq","range":"Form_range__3GUgt","name":"Form_name__1_C8m","actions":"Form_actions__3b6ah"};